<template>
    <Card title="appointments.do_report" containerClass="shadow-sm">
        <template #cardToolbar>
            <div class="d-flex align-items-center text-end" v-if="appointment?.notes?.length > 0 && appointment.status == 'COMPLETED'">
                <Button type="new" btn-class="btn-sm" btn-text="appointments.update" @click="openUpdateNote" :is-disabled="appointment.status == 'CANCELLED'"></Button>
            </div>
        </template>
        <template #cardBody>
            <div class="row">
                <div class="col-12 col-md-7 col-lg-7 mb-5">
                  <div  v-html="note"> </div>

<!--                    <CKEditor-->
<!--                        :required="false"-->
<!--                        id="appointments_report" -->
<!--                        :content="note"-->
<!--                        @text="getNote"-->
<!--                        :disabled=true-->
<!--                    />-->

                </div>

                <div class="col-12 col-md-5 col-lg-5">
                    <Card title="pipelines.attach_files" containerClass="card mb-5 min-h-200px " style="background-color: #0072CE0D;">
                        <template #cardToolbar>
                            <span :style="{color: primaryColor, fontSize: '18px', fontWeight: '600'}">{{attachFiles?.length}}</span>
                        </template>
                        <template #cardBody>
                            <div>
                                <FileUploaded :remove="false" :attach-files="attachFiles" :is-disabled="appointment.status == 'CANCELLED'"/>
                            </div>
                        </template>
                    </Card>
                </div>
            </div>
        </template>
    </Card> 
    <ReportModal id="update_note_modal" :appointmentData="formData" :isEdit="true" @load="loadData"/>
</template>

<script setup>
import Card from "@/Modules/CRM/components/Card";
import CKEditor from "@/components/CKEditor.vue";
import {useRoute} from "vue-router";
import FileUploaded from "@/components/FileUploaded";
import {ref, watch, inject, computed} from "vue"
import Button from "@/components/Button.vue";
import {useStore} from "vuex";
import ReportModal from "@/Modules/CRM/components/Modals/Appointment/ReportModal.vue"

const emits = defineEmits(['load'])

const store = useStore()

const route = useRoute()

const props = defineProps({
  appointment: Object,
  files: Array
})

const formData = ref({
    appointment_id: route.params.id,
    appointment_note_id: '',
    files: [],
    note: '',
    detach_files: [],
    title: '',
    start_time: '',
})

const attachFiles = ref([])
const note = computed(() => props.appointment?.notes?.length > 0 ? props.appointment?.notes[0]?.note : '')

watch(() => props.appointment, (newValue) => {
    formData.value.note = newValue?.notes[0]?.note
    attachFiles.value = []
    if(newValue?.notes[0]?.files.length > 0){

        newValue?.notes[0]?.files.filter((item) => {
            attachFiles.value.push({
                name: item.file,
                url: item.file_url,
                type: item.file_url?.split('.')[1],
                id: item.id
            })
        })
    }
    formData.value.files = newValue?.notes[0]?.files
    formData.value.appointment_note_id = newValue?.notes[0]?.id
})

const primaryColor = ref('#0072CE')

function getNote(text) {
    formData.value.note = text
}

function openUpdateNote(){
    formData.value.title = props.appointment.title
    formData.value.start_time = props.appointment.start_time
    formData.value.appointment_note_id = props.appointment?.notes[0]?.id
    $('#update_note_modal').modal('toggle')
}

function loadData(){
    emits('load')
}

</script>